import { render, staticRenderFns } from "./attendance-manage.vue?vue&type=template&id=378ff70d"
import script from "./attendance-manage.vue?vue&type=script&lang=ts"
export * from "./attendance-manage.vue?vue&type=script&lang=ts"
import style0 from "./attendance-manage.vue?vue&type=style&index=0&id=378ff70d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports